import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet, useNavigation } from "react-router-dom";
import { cn } from "@/utils/styleHelper";
export default function RootLayout() {
    const navigation = useNavigation();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("main", {
            className: cn('items-center justify-between', {
                'opacity-50': navigation.state === 'loading'
            }),
            children: /*#__PURE__*/ _jsx(Outlet, {})
        })
    });
}
